import { formatCurrency } from "@angular/common";
import { Inject, LOCALE_ID, Optional, Pipe, PipeTransform } from "@angular/core";
import { MathHelper } from '../helpers/math-helper';
import { TCM_FORM_CONFIG, TCMFormConfig } from "../tcm-form-config";

@Pipe({
    name: 'wafCurrency',
    standalone: false
})
export class CurrencyStringPipe implements PipeTransform {

    constructor(@Inject(LOCALE_ID) private locale: string, @Optional() @Inject(TCM_FORM_CONFIG) protected config: TCMFormConfig) {
    }

    transform(value: number, sign?: string, digitInfo?: string): string {

        if (value != undefined) {

            sign = sign || (this.config ? this.config.currencySign : null) || '$';

            value = MathHelper.roundToTwoDecimalPlaces(value);

            return formatCurrency(value, this.locale, sign, null, digitInfo || this.config.digitInfo);
        }

        return '';
    }
}